import { ReactNode, useState } from 'react';

import { useRouter } from 'next/router'

import Link from 'next/link';

import { AppConfig } from '@/utils/AppConfig';
import { useCookie } from '@/utils/Session';

import { useSessionContext, ISessionContext } from '../pages/_app'
import { Footer } from '@/layout/Footer';

type ILegalProps = {
  meta: ReactNode;
  children: ReactNode;
};

const Legal = (props: ILegalProps) => {
  const router = useRouter();
  const [isLoggedIn,,deleteIsLoggedIn] = useCookie('loggedIn')
  const [,,deleteSessionId] = useCookie('sessionId')
  const [sessionEmail] = useSessionContext() as ISessionContext

  const handleLogout = () => {
    deleteSessionId()
    deleteIsLoggedIn()
    router.push('/')
  }

  return (
    <div className="antialiased w-full text-gray-700 px-1">
      {props.meta}

      <img
        className="w-full object-cover -z-30 absolute top-0 left-0"
        src={`${router.basePath}/assets/images/bing-bot.jpeg`}
        alt="Database watercolor"
      />

      <div className="max-w-screen-md mx-auto bg-white pt-0 p-7">
        <div className="border-b border-gray-300">
          <div className="pt-16 pb-8">
            <div className="float-right">
              {!isLoggedIn() ? (
                <>
                <button 
                  className="bg-blue-400 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mx-2"
                  data-umami-event={"Clicked Login Button"}
                >
                  <Link href="/login/">Login</Link>
                </button>
                <button 
                  className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                  data-umami-event={"Clicked Get Started Button"}
                >
                  <Link href="/signup/">Create Account</Link>
                </button>
                </>
              ) : (
                <div>
                  Welcome {sessionEmail} | <a href="" onClick={() => handleLogout()}>Logout</a>
                </div>
              )}
            </div>
            <div className="font-bold text-5xl text-gray-700">
              {AppConfig.title}
            </div>
            <div className="text-xl">{AppConfig.description}</div>
          </div>
        </div>

        <div className="py-5 text-xl content">{props.children}</div>
        
        <Footer />
        <div className='text-center'>
        Powered with{' '}
          <span role="img" aria-label="Love">
            ♥
          </span>{' '}
          by <a href="https://creativedesignsguru.com">CreativeDesignsGuru</a>
          {/*
          * PLEASE READ THIS SECTION
          * We'll really appreciate if you could have a link to our website
          * The link doesn't need to appear on every pages, one link on one page is enough.
          * Thank you for your support it'll mean a lot for us.
          */}
        </div>
      </div>
    </div>
  );
};

export { Legal };
